import { ColorEnum } from '@/constants/color'
import Select from '@/features/ui/inputs/components/Select'
import Option from '@/features/ui/inputs/components/Select/parts/Option'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface LabeledSelectProps {
    value: string
    onValueChange: (value: string) => void
    options: { [value: string]: string }
    label: string
}

const LabeledSelect: FC<LabeledSelectProps> = ({ value, onValueChange, label, options }) => {
    return (
        <View style={styles.container}>
            <Typography.Heading variant="h5" numberOfLines={1}>
                {label}
            </Typography.Heading>
            <Select
                value={value}
                onValueChange={onValueChange}
                label=""
                placeholder=""
                style={styles.select}
            >
                {Object.entries(options).map(([value, label]) => (
                    <Option key={value} value={value}>
                        {label}
                    </Option>
                ))}
            </Select>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        gap: 8,
        flex: 1,
    },
    select: {
        backgroundColor: ColorEnum.WHITE,
        minWidth: 0,
    },
})

export default LabeledSelect
